import React, { ReactEventHandler, useEffect, useState } from 'react'
import { AlertType, classBorderLabelDark, classBt, classInput, classInputDark, classLabel, classLabelDark, classbtAzul, classbtColunasVermelho } from '../../Utils/Types'
import { MarcaService } from '../../Pages/Marca/MarcaService'
import { FeedbackMessage } from '../FeedbackMessage/feedback-message'
import { GrupoService } from '../../Pages/Grupo/GrupoService'
import { FaSave } from 'react-icons/fa'
import { GiArchiveRegister } from 'react-icons/gi'

type Props = {

    setIdMarca: (id: number) => void
    setIdGrupo: (id: number) => void
    visible: boolean
    modalType: string
    modalConfirmClick?: ReactEventHandler
    closeModal: () => void

}

export const ModalMarcaGrupo = React.memo(({ setIdMarca, setIdGrupo, visible, modalType, modalConfirmClick, closeModal }: Props) => {

    const [loading, setLoading] = useState(false)
    const [visibleMSG, setVisibleMSG] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("DANGER")

    const [idDaMarca, setIdDaMarca] = useState(0)
    const [idDoGrupo, setIdDoGrupo] = useState(0)
    const [descMarcaGrupo, setDescMarcaGrupo] = useState("")

    useEffect(() => {

        if (visible) {

            let modal = document.getElementById('modal_marca_grupo')
            let modalContent = document.getElementById('modal_content_marca_grupo')

            if (modal) {
                modal.style.visibility = 'visible'


                if (modalContent) {
                    modalContent.classList.remove('mt-[-400px]')
                    modalContent.classList.add('mt-24')
                }
            }

            const aguarde = setTimeout(() => {
                InputFocus()
                clearTimeout(aguarde)
            }, 200)

        } else {

            let modal = document.getElementById('modal_marca_grupo')
            let modalContent = document.getElementById('modal_content_marca_grupo')

            if (modal) {
                modal.style.visibility = 'hidden'


                if (modalContent) {
                    modalContent.classList.add('mt-[-400px]')
                    modalContent.classList.remove('mt-24')
                }
            }

            setDescMarcaGrupo("")
            setIdDaMarca(0)
            setIdDoGrupo(0)
            setVisibleMSG(false)
            setLoading(false)

        }

    }, [visible])

    const hadleChangeDesc = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDescMarcaGrupo(e.target.value)
    }

    const handleCloseMessage = () => {
        setVisibleMSG(false)
    }

    const handleSave = async (e: any) => {

        setVisibleMSG(false)

        if (modalType === 'grupo') {

            try {

                let grupo: any = {
                    id: idDoGrupo || 0,
                    description: descMarcaGrupo
                }

                setLoading(true)
                const resp = await GrupoService.Save(grupo)
                //setLoading(false)

                InputFocus()

                if (resp.error) {

                    setVisibleMSG(true)
                    setMessageType("DANGER")
                    setMessage(resp.msg || "")
                    setLoading(false)

                } else {

                    setVisibleMSG(true)
                    setMessageType("SUCCESS")
                    setMessage("Dados salvos com sucesso")

                    setIdDoGrupo(resp.id || 0)
                    setIdGrupo(resp.id || -1)

                    const aguarde = setTimeout(() => {
                        if (modalConfirmClick) {
                            modalConfirmClick(e)
                        }
                        clearTimeout(aguarde)
                    }, 500)

                }

            } catch (error) {

                setVisibleMSG(true)
                setMessageType("DANGER")
                setMessage("Ocorreu um erro ao salvar o grupo")
                setLoading(false)

            }

        } else if (modalType === 'marca') {

            try {

                let marca: any = {
                    id: idDaMarca || 0,
                    description: descMarcaGrupo
                }

                setLoading(true)
                const resp = await MarcaService.Save(marca)
                //setLoading(false)

                InputFocus()

                if (resp.error) {

                    setVisibleMSG(true)
                    setMessageType("DANGER")
                    setMessage(resp.msg || "")
                    setLoading(false)

                } else {

                    setVisibleMSG(true)
                    setMessageType("SUCCESS")
                    setMessage("Dados salvos com sucesso")

                    setIdDaMarca(resp.id || 0)
                    setIdMarca(resp.id || -1)

                    const aguarde = setTimeout(() => {
                        if (modalConfirmClick) {
                            modalConfirmClick(e)
                        }
                        clearTimeout(aguarde)
                    }, 500)
                }

            } catch (error) {

                setVisibleMSG(true)
                setMessageType("DANGER")
                setMessage("Ocorreu um erro ao salvar a marca")
                setLoading(false)

            }
        }
    }

    const InputFocus = () => {
        const input = document.getElementById('Marca_Grupo')
        if (input) {
            input.focus()
        }
    }

    const handleKeyPressEnter = async (event: any) => {

        if ((event.code === "Enter" || event.code === "NumpadEnter") && visible) {

            event.preventDefault() // Evita o comportamento padrão do 'Enter'

            InputFocus()

        }
    }

    const handleTabPress = (event: any) => {

        if (event.key === 'Tab' && visible) {

            event.preventDefault() // Evita o comportamento padrão do 'Tab'
        }
    }

    useEffect(() => {

        document.addEventListener('keydown', handleKeyPressEnter)
        document.addEventListener('keydown', handleTabPress)

        return () => {

            document.addEventListener('keydown', handleKeyPressEnter)
            document.addEventListener('keydown', handleTabPress)
        }
    }, [visible])

    return (

        <div id="modal_marca_grupo" style={{ visibility: "hidden", backgroundColor: 'rgba(0,0,0, 0.6)' }} className={`flex justify-center fixed left-0 right-0 top-0 bottom-0 transition-all duration-300 z-40`}>

            <div id="modal_content_marca_grupo" className={`relative flex flex-col w-[90%] sm:w-[70%] md:w-[50%] lg:w-[40%] xl:w-[30%] 2xl:w-[25%] h-[230px] bg-white dark:bg-slate-600 rounded-lg mt-[-400px] transition-all duration-300 justify-center items-center`}>

                <FeedbackMessage visible={visibleMSG} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                <div className={`absolute top-0 w-full h-[70px] flex items-center`}>

                    <div className={`ml-4 flex items-center justify-center h-10 w-10 rounded-full bg-slate-100 dark:bg-slate-500 border border-slate-300 dark:border-slate-700 shadow-sm shadow-slate-500 dark:shadow-slate-800`}>
                        <GiArchiveRegister className={`w-5 h-5 text-gray-800 dark:text-slate-100`} />
                    </div>

                    <span className={`ml-4 text-lg text-slate-700 dark:text-slate-200 flex items-center font-semibold`}>{modalType == "marca" ? "Cadastro - Marca" : "Cadastro - Grupo"}</span>

                </div>

                <div className={`absolute top-[70px] bottom-[60px] w-full h-full px-3 py-4`}>

                    <div className={`relative w-full col-span-3`}>
                        <input id="Marca_Grupo" className={`${classInput} ${classInputDark}`} type="text" inputMode='text' placeholder=" " autoComplete="off" value={descMarcaGrupo} onChange={hadleChangeDesc} />
                        <label htmlFor="Marca_Grupo" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Descrição</label>
                    </div>

                </div>

                <div className={`absolute bottom-0 w-full h-[60px] flex items-center justify-end bg-slate-100 dark:bg-slate-600 border border-slate-200 dark:border-slate-500 border-x-0 border-b-0 py-4 px-3 rounded-b-lg space-x-3`}>

                    <button
                        tabIndex={-1}
                        disabled={loading}
                        onClick={closeModal}
                        className={`${loading ? 'opacity-40' : ''} ${classbtColunasVermelho} sm:max-w-[150px] `}>
                        CANCELAR
                    </button>

                    <button
                        tabIndex={-1}
                        disabled={loading}
                        onClick={handleSave}
                        className={`${loading ? 'opacity-40' : ''} ${classbtAzul} ${classBt} sm:max-w-[150px]`}>
                        {!loading && <FaSave size={"18px"} className='mr-2' />}
                        {loading &&
                            <div className="h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-neutral-100 motion-reduce:animate-[spin_1.5s_linear_infinite]"
                                role="status">
                                <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">Loading...</span>
                            </div>
                        }
                        {!loading ? `SALVAR` : "AGUARDE"}
                    </button>

                </div>

            </div>

        </div>

    )
})